import { render } from "./AddRedEnvelope.vue?vue&type=template&id=50f92460"
import script from "./AddRedEnvelope.vue?vue&type=script&lang=js"
export * from "./AddRedEnvelope.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__